// index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication, Configuration } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { RegistrationProvider } from "./contexts/ClientRegistrationContext";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Auth0Provider } from "@auth0/auth0-react";
import { AllOrdersProvider } from "./contexts/AllOrdersContext";
import { AdminReviewProvider } from "./contexts/AdminReviewContext";
import { InProgressProvider } from "./contexts/InProgressContext";
import { CompletedOrdersProvider } from "./contexts/CompletedOrdersContext";
import { DeletedOrdersProvider } from "./contexts/DeletedOrdersContext";
import { PendingOrdersProvider } from "./contexts/PendingOrdersContext";
import { ViewOrderProvider } from "./contexts/ViewOrderContext";

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "";
const TENANT_ID = process.env.REACT_APP_TENANT_ID || "";
const STRIPE_KEY =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_STRIPE_TEST_KEY
    : process.env.REACT_APP_STRIPE_KEY;

const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || "";
const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID || "";
const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE || "";

const APP_URL = process.env.REACT_APP_APP_URL || "";
const DEV_APP_URL = process.env.REACT_APP_DEV_APP_URL || "";
const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";

const siteBaseUrl =
  window.location.hostname === "localhost"
    ? APP_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
    ? PROD_APP_URL
    : DEV_APP_URL;

// Strip configuration
const stripePromise = loadStripe(STRIPE_KEY ?? "");

// MSAL configuration
const msalConfig: Configuration = {
  auth: {
    clientId: `${CLIENT_ID}`,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Auth0Provider
        domain={AUTH0_DOMAIN}
        clientId={AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: siteBaseUrl,
          audience: AUTH0_AUDIENCE,
          connection: "email",
          scope: "openid profile",
        }}
      >
        <RegistrationProvider>
          <AllOrdersProvider>
            <AdminReviewProvider>
              <InProgressProvider>
                <CompletedOrdersProvider>
                  <DeletedOrdersProvider>
                    <PendingOrdersProvider>
                      <ViewOrderProvider>
                        <Elements stripe={stripePromise}>
                          <App />
                        </Elements>
                      </ViewOrderProvider>
                    </PendingOrdersProvider>
                  </DeletedOrdersProvider>
                </CompletedOrdersProvider>
              </InProgressProvider>
            </AdminReviewProvider>
          </AllOrdersProvider>
        </RegistrationProvider>
      </Auth0Provider>
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();
